import type {SanityModuleSingleColText} from '../../types';
import PortableText from '../portableText/PortableText.client';
import ModuleWrapper from './ModuleWrapper.client';
import slugify from 'slugify';

export default function SingleColTextModule({
  module,
}: {
  module: SanityModuleSingleColText;
}) {
  const {config, text, centerText, layout, animate}: any = module;
  return (
    <ModuleWrapper {...config} className="relative z-20 grid grid-cols-14">
      <div
        data-testid={`section-${slugify(text[0].children[0].text, {
          lower: true,
          trim: true,
        })}`}
      ></div>
      <PortableText
        blocks={text}
        animate={animate || false}
        className={`col-start-2 col-end-14 ${
          layout === 'center'
            ? 'md:col-start-5 md:col-end-11'
            : 'md:col-start-3 md:col-end-13'
        } ${centerText && 'btn-center text-center'}`}
      />
    </ModuleWrapper>
  );
}
